import React from "react";
import { useGlobalUtils } from "../../../lib/globalUtils";
import { getUserPhone } from "../../../constants/userConstants";

const OverviewTab = ({
  user,
  ordersCount,
  walletBalance,
  showStats = true,
}) => {
  const { parsePrice, parseDate } = useGlobalUtils();

  // Extract user information
  const phone = getUserPhone(user);
  const email = user?.email || "N/A";
  const address = user?.addresses?.[0] || user?.address;

  return (
    <div className="space-y-6">
      {/* Statistics Cards - Only show for non-admin users */}
      {showStats && (
        <div
          className={`grid grid-cols-1 ${walletBalance ? "md:grid-cols-2" : ""} gap-6`}
        >
          <div className="border-border bg-card rounded-lg border p-6">
            <div className="text-center">
              <p className="text-muted-foreground mb-2 text-sm">Total Orders</p>
              <p className="text-foreground text-3xl font-bold">
                {ordersCount}
              </p>
            </div>
          </div>

          {!!walletBalance && (
            <div className="border-border bg-card rounded-lg border p-6">
              <div className="text-center">
                <p className="text-muted-foreground mb-2 text-sm">
                  Cash Wallet Balance
                </p>
                <p className="text-success text-3xl font-bold">
                  {parsePrice(walletBalance)}
                </p>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Customer Info */}
      <div className="border-border bg-card rounded-lg border p-6">
        <h3 className="text-foreground mb-4 text-lg font-semibold">
          Customer Info
        </h3>
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Phone:</span>
            <span className="text-foreground">{phone}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Email:</span>
            <span className="text-foreground">{email}</span>
          </div>
          {!!address?.id && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Address:</span>
              <span className="text-foreground">{address?.address}</span>
            </div>
          )}
          <div className="flex justify-between">
            <span className="text-muted-foreground">Joined:</span>
            <span className="text-foreground">
              {parseDate(user?.created_at)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
